<script>
import Typed from "@/app/admin/system/ai/aitype.vue";
export default {

  data() {
    return {
      avatarPath: require('@/assets/ai-assistant-avatar.png'),
      copyIconPath: require('@/assets/ai-assistant_copy.png'),
      messageCopy: false,
    };
  },
  props: {
    message: {
      type: String,
      default: '',
      required: false
    },
    showCopyButton: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  components:{
    Typed
  },
  methods: {
    copyText(){
      this.promotionLinks = false;
      // this.$message.info("复制成功！");
    },
    copySuccess(){
      this.$message.info("复制成功！");
    },
    onError(){
      this.promotionLinks = false;
      this.$message.info("复制失败！");
    }
  }
};
</script>
<template>
  <div class="ai-assistant-item-content">
    <div class="row">
      <!--头像-->
      <div class="col ai-assistant-fixed-col-avatar">
        <div class="ai-assistant-item-avatar-bg">
          <img class="ai-assistant-avatar-image" :src="avatarPath" alt="avatarImage" />
        </div>
      </div>
      <!--内容-->
      <span id = "message" class="col ai-assistant-message-content" v-html="message"></span>
     
     
     
      <!--拷贝 -->
      <div class="ai-assistant-message-copy" v-if="showCopyButton" @click = "copyText"
           v-clipboard:copy="message"
           v-clipboard:success="copySuccess"
           v-clipboard:error="onError">
        <img class="ai-assistant-copy-image" :src="copyIconPath" alt="copyImage" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ai-assistant-item-content {
  margin: 15px;
}

.row {
  display: flex;
  justify-content: left;
  //align-items: flex-start;
}

.col {
  flex: 1;
}

.ai-assistant-fixed-col-avatar{
  flex: 0 0 50px;
}

.ai-assistant-item-avatar-bg {
  flex: 0 0 24px;
  width: 40px;
  height: 40px;
  background: #edf6fd;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-assistant-message-content{
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
  padding: 12px;
  max-width: 80%;
  white-space: pre-line;
  word-wrap: break-word;
  overflow-wrap: break-word; /* 添加这行样式，以便支持旧版本浏览器 */
}

.ai-assistant-avatar-image {
  width: 24px;
  height: 24px;
}
.ai-assistant-copy-image img {
  width: 12px;
  height: 12px;
}
.ai-assistant-message-copy{
  width: 24px;
  height: 24px;
  background-size: 12px;
  margin-left: 4px;
  background-color: #7788FFFF;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>